import { render, staticRenderFns } from "./ProfilePreferencesDialog.vue?vue&type=template&id=b1c90d0a&"
import script from "./ProfilePreferencesDialog.vue?vue&type=script&lang=js&"
export * from "./ProfilePreferencesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
